// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Nav, NavItem, NavLink } from 'react-bootstrap';

// Services & Helpers
import BookingService from 'services/BookingService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import EditBookingModal from 'components/bookings/EditBookingModal';

//-------------------------------------------------------------------------------------------------------------------

class ImportPage extends React.Component {

    constructor(props) {
        super(props);

        this.editBookingModalRef = React.createRef();

        this.state = {
            
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
    }

    async upload(field) {
        if (field.files.length > 0) {
            const file = field.files[0];
            this.setState({
                isUploading: true,
                isCompleted: false
            });
            const response = await BookingService.importPreflight(file);
            field.value = '';

            // Count items and auto-tick
            const isSelected = {};
            const actionRequiredResults = [];
            const successResults = [];
            const unchangedResults = [];
            const errorResults = [];
            response.results.results.forEach(r => {
                if (r.anyErrors) {
                    errorResults.push(r);
                } else if (r.isActionRequired) {
                    actionRequiredResults.push(r);
                    if (!r.isActionReqSelectBooking && r.isSelected) {
                        isSelected[r.firstRowNum] = true;
                    }
                } else if (Object.keys(r.changedFields).length > 0) {
                    successResults.push(r);
                    if (r.isSelected) {
                        isSelected[r.firstRowNum] = true;
                    }
                } else {
                    unchangedResults.push(r);
                }
            });

            this.setState({
                fileName: file.name,
                isUploading: false,
                results: response.results.results,
                isSelected,
                actionRequiredResults,
                successResults,
                unchangedResults,
                errorResults,
                guid: response.guid,
                page: (errorResults.length > 0 ? 'errors' : '')
            });
        }
    }

    async tryImport() {
        let numWithoutAction = 0;
        this.state.actionRequiredResults.forEach(r => {
            if ((r.isActionReqSelectBooking && !r.selectBookingAction) ||
                (r.isActionReqAvailability && !r.availabilityAction)
            ) {
                numWithoutAction++;
            }
        });
        if (numWithoutAction > 0) {
            const msg = (numWithoutAction == 1 ?
                'There is 1 item with no decision selected. This item won\'t be imported. Continue?' :
                `There are ${numWithoutAction} items with no decision selected. These items won\'t be imported. Continue?`
            );
            const confirm = await BootboxHelper.confirm(msg);
            if (confirm) {
                this.import();
            }
        } else {
            this.import();
        }
    }

    async import() {
        this.setState({
            results: null,
            isImporting: true
        });

        const selectBookingActions = {};
        const availabilityActions = {};

        this.state.actionRequiredResults.forEach(r => {
            if (r.selectBookingAction) {
                selectBookingActions[r.firstRowNum] = r.selectBookingAction;
            }
            if (r.availabilityAction) {
                availabilityActions[r.firstRowNum] = r.availabilityAction;
            }
        });

        const response = await BookingService.import(
            this.state.guid,
            this.state.fileName,
            selectBookingActions,
            availabilityActions,
            this.state.isSelected
        );

        this.setState({
            isImporting: false,
            isCompleted: true,
            results: response.results
        });
    }

    updateResultAction(index, fieldName, value) {
        const actionRequiredResults = [...this.state.actionRequiredResults];
        const result = { ...actionRequiredResults[index] };
        result[fieldName] = value;
        if (fieldName == 'selectBookingAction') {
            this.setSelected(result.firstRowNum, !!value);
        }
        actionRequiredResults[index] = result;
        this.setState({
            actionRequiredResults
        });
    }

    setSelected(rowNum, value) {
        const isSelected = { ...this.state.isSelected };
        if (value) {
            isSelected[rowNum] = true;
        } else {
            delete isSelected[rowNum];
        }
        this.setState({ isSelected });
    }

    explainAvailabilityMismatch(result) {
        let msg = 'Instructor has not marked the following dates as available:';
        msg += '<ul>';
        result.missingAvailableDates.forEach(d => {
            msg += `<li>${d}</li>`;
        });
        msg += '</ul>';
        BootboxHelper.confirm(msg);
    }

    //-------------------------------------------------------------------------------------------------------

    render() {
        const {
            isImporting,
            isCompleted,
            isUploading,
            fileName,
            results,
            successResults,
            actionRequiredResults,
            isSelected
        } = this.state;

        let numToImport = (isSelected ? Object.keys(isSelected).length : 0);

        return (<>

            <header className="import-page page-header sticky">
                <Container>
                    <h1>
                        Import Bookings File

                        <div className="control-panel">

                            {!isImporting && !isCompleted && results && (successResults.length > 0 || actionRequiredResults.length > 0) &&
                                <button className="btn btn-block" onClick={() => this.tryImport()}>
                                    Import {numToImport} item{numToImport == 1 ? '' : 's'}
                                </button>
                            }
                            {isCompleted && 
                                <button className="btn btn-block" onClick={() => window.location.reload()}>
                                    Start again
                                </button>
                            }

                            {!isImporting && !results && !isCompleted &&
                                <label className="btn btn-block upload-button">
                                    {isUploading ? <>
                                        <Loader isInline />{' '}Uploading...
                                    </> : <>
                                        {fileName ? <>
                                            <span className="fa-solid fa-check"></span>{' '}{fileName}
                                        </> : <>
                                            <span className="fa-solid fa-upload"></span>{' '}Upload
                                        </>}
                                        <input
                                            type="file"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            onChange={e => this.upload(e.target)}
                                        />
                                    </>}
                                </label>
                            }

                        </div>

                    </h1>

                </Container>
            </header>

            <Container tag="main" className="import-page">

                <section className={isImporting ? '' : 'loaded'}>

                    {this.renderInner()}

                </section>

            </Container>

            <EditBookingModal ref={this.editBookingModalRef} />

        </>);
    }

    renderInner() {
        const {
            isImporting,
            isCompleted,
            unchangedResults,
            successResults,
            actionRequiredResults,
            errorResults,
            results,
            page
        } = this.state;

        if (isImporting) {
            return (<Loader />);
        }

        if (!results) {
            return (<>
                <h2>Please upload an .XLSX file</h2>
            </>);
        }
        if (isCompleted) {
            return (<>
                <h2>Import completed <span className="fa-solid fa-check" /></h2>
            </>);
        }

        return (<>

            <Nav pills>
                <NavItem>
                    <NavLink
                        active={(page || '') == ''}
                        onClick={() => this.setState({ page: '' })}
                    >
                        Changed ({successResults.length})
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={(page || '') == 'action-required'}
                        onClick={() => this.setState({ page: 'action-required' })}
                    >
                        Decision required ({actionRequiredResults.length})
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={(page || '') == 'errors'}
                        onClick={() => this.setState({ page: 'errors' })}
                    >
                        Has errors ({errorResults.length})
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={(page || '') == 'unchanged'}
                        onClick={() => this.setState({ page: 'unchanged' })}
                    >
                        Unchanged ({unchangedResults.length})
                    </NavLink>
                </NavItem>
            </Nav>

            {(page || '') == '' && this.renderTable(successResults, false)}
            {page == 'action-required' && this.renderTable(actionRequiredResults, true)}
            {page == 'errors' && this.renderTable(errorResults, false)}
            {page == 'unchanged' && this.renderTable(unchangedResults, false)}
            
        </>);
    }

    renderTable(results, renderActionRequired) {
        const {
            isSelected
        } = this.state;

        if (results.length == 0) {
            return (
                <div className="empty-text">
                    No items
                </div>
            );
        }
        return (
            <table className="table table-bordered import-results-table">
                <thead>
                    <tr>
                        <th className="import-col"></th>
                        <th>LMS ID &amp; Row #</th>
                        <th>Field</th>
                        <th>Old value</th>
                        <th>New value</th>
                    </tr>
                </thead>
                <tbody>
                    {results.map((result, index) => {
                        const changedFields = (result.changedFields || [{}]);

                        if (result.changedFields.length == 0) {
                            return (
                                <tr key={index}>
                                    <td className="import-col">&nbsp;</td>
                                    <td>
                                        {result.lmsid}<br />
                                        Row{result.rowNums.length == 1 ? '' : 's'} {result.rowNums.join(', ')}

                                        {renderActionRequired && result.isActionRequired &&
                                            this.renderActionRequired(result, index)
                                        }
                                    </td>
                                    <td colSpan={3}>
                                        (No changes)
                                    </td>
                                </tr>
                            );
                        }

                        return (
                            <React.Fragment key={index}>
                                {changedFields.map((changedField, cfIndex) => {

                                    let rowClassName = '';
                                    if (changedField.error) {
                                        rowClassName = 'error';
                                    } else if (!isSelected[result.firstRowNum]) {
                                        rowClassName = 'dont-import';
                                    }

                                    let canImport = false;
                                    if (!result.anyErrors) {
                                        if ((!result.isActionReqSelectBooking || result.selectBookingAction) && (!result.isActionReqAvailability || result.availabilityAction)) {
                                            if (Object.keys(result.changedFields).length > 0) {
                                                canImport = true;
                                            }
                                        }
                                    }

                                    return (
                                        <tr key={cfIndex} className={rowClassName}>
                                            {cfIndex == 0 && <>
                                                <td className="import-col" rowSpan={changedFields.length}>

                                                    <input
                                                        id={`isSelected-${result.firstRowNum}`}
                                                        type="checkbox"
                                                        checked={!!isSelected[result.firstRowNum]}
                                                        onChange={e => this.setSelected(result.firstRowNum, e.target.checked)}
                                                        disabled={!canImport}
                                                    />

                                                </td>
                                                <td rowSpan={changedFields.length}>
                                                    {!result.isNew &&
                                                        <button className="btn btn-sm float-end" onClick={() => {
                                                            this.editBookingModalRef.current.show({
                                                                bookingID: result.id
                                                            });
                                                        }}>
                                                            <span className="fa-solid fa-search" />
                                                        </button>
                                                    }

                                                    <label htmlFor={`isSelected-${result.firstRowNum}`}>
                                                        {result.lmsid || 'No LMS ID'} {!result.isActionReqSelectBooking && result.isNew && '(New)'}<br />
                                                        Row{result.rowNums.length == 1 ? '' : 's'} {result.rowNums.join(', ')}
                                                    </label>

                                                    {renderActionRequired && result.isActionRequired &&
                                                        this.renderActionRequired(result, index)
                                                    }
                                                </td>
                                            </>}
                                            <td>
                                                {changedField.field}
                                            </td>
                                            <td>
                                                {result.isNew ? 'N/A' : changedField.oldValue}
                                            </td>
                                            <td>
                                                {changedField.newValue}

                                                {changedField.notes &&
                                                    <div className="notes">{changedField.notes}</div>
                                                }
                                                {changedField.error &&
                                                    <div className="error">{changedField.error}</div>
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                            </React.Fragment>
                        );
                    })}
                    {results.length == 0 &&
                        <tr>
                            <td colSpan={7} className="empty-text">
                                There are no changes to apply
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        );
    }

    renderActionRequired(result, index) {

        return (<>
            <div className={'action-required ' + (result.action ? 'completed' : '')}>

                {result.isActionReqSelectBooking && <>

                    {result.selectBookingAction && result.selectBookingAction != 'new' &&
                        <button className="btn btn-sm float-end" onClick={() => {
                            this.editBookingModalRef.current.show({
                                bookingID: parseInt(result.selectBookingAction)
                            });
                        }}>
                            <span className="fa-solid fa-search" />
                        </button>
                    }

                    <span>Select matching booking</span>

                    <select
                        value={result.selectBookingAction}
                        onChange={e => this.updateResultAction(index, 'selectBookingAction', e.target.value)}
                    >
                        <option value="">(Please select)</option>
                        {result.matchingBookings.map(mb =>
                            <option value={mb.id}>
                                {mb.datesFormatted}
                            </option>
                        )}
                        <option value="new">Import as a new booking</option>
                    </select>

                </>}

                {result.isActionReqAvailability && <>

                    <button className="btn btn-sm float-end" onClick={() => this.explainAvailabilityMismatch(result)}>
                        <span className="fa-solid fa-search" />
                    </button>

                    <span>Instructor availability does not match booking dates</span>

                    <select
                        value={result.availabilityAction}
                        onChange={e => this.updateResultAction(index, 'availabilityAction', e.target.value)}
                    >
                        <option value="leave">Leave availability as-is</option>
                        <option value="update">Update availability</option>
                    </select>

                </>}

            </div>
        </>);
    }
}

export default withRouter(ImportPage);